import React from "react"
import { useTranslation } from "react-i18next"
import { useAppContext } from "../../../AppContext"
import PayrollAttachments from "./PayrollAttachments"

const PayrollComments = ({
  payroll,
  setPayroll,
  handleChange,
  payrollAttachments,
  setPayrollAttachments,
  disabled
}) => {

  const { t } = useTranslation("translations");

  return (
    <div className="row">
      <div className="col-12 mb-2">
        <div className=" font-weight-bold d-flex align-items-center input-length-validation">
          <textarea
            style={{paddingRight:"75px"}}
            placeholder={t('invoice.comment')}
            className="form-control"
            value={payroll?.comment ?? ""}
            id="comment"
            rows="2"
            onChange={(e)=>handleChange(null,"comment",e.target.value)}
            disabled={disabled}
          />
        </div>
      </div>
      <div className="col-12">
        <PayrollAttachments
          payroll={payroll}
          setPayroll={setPayroll}
          payrollAttachments={payrollAttachments}
          setPayrollAttachments={setPayrollAttachments}
          disabled={disabled}
        />
      </div>

    </div>
  )
}

export default PayrollComments